import React, { useMemo } from "react"
import ClassNames from "classnames"
import { get, merge, set, filter, fill, includes } from "lodash"

import { infoTableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { CreditTable, InfoTable } from "components/molecules/table"
import { useDetailInformation } from "components/actions/symbolDetail"
import { checkIsSp } from "utils/util"
import { SECURITY_TYPE } from "config/const"
import { useSelector } from "react-redux"

type InfoPropsType = {
  symbolDetail: APIResponse.Res
}

export const Info: React.FC<InfoPropsType> = props => {
  const symbolData = get(props.symbolDetail, "Symbol")
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const [companyInfo, expectData] = useDetailInformation(symbolData, isRefresh)
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const data = useMemo(() => {
    return merge(
      get(companyInfo, "CompanyInfo"),
      get(companyInfo, "AnnounceSettlementDay"),
      get(companyInfo, "Symbol")
    )
  }, [companyInfo])
  //外国株判定
  const isDomesticEquity = get(data, "SecurityType") === SECURITY_TYPE.Equity.id
  const infoTableList = useMemo(() => {
    let _infoTableList = { ...infoTableColumns.symbolDetail.detail.info }
    return (_infoTableList = isDomesticEquity
      ? // 日株は、『　代表者役職名　株式数更新日　浮動株数　』を表示ないため除く。
        set(_infoTableList, "list", [
          filter(
            get(_infoTableList, ["list", 0]),
            (_, index) => !includes([4, 11, 12], index)
          ),
        ])
      : // 外国株は、『　上場日　決算発表予定日時　業種(東証33業種)　』を表示ないため除く。
        set(_infoTableList, "list", [
          filter(
            get(_infoTableList, ["list", 0]),
            (_, index) => !includes([7, 9, 13], index)
          ),
        ]))
  }, [data])
  const expectTableList = useMemo(() => {
    let _expectTableLis = { ...infoTableColumns.symbolDetail.detail.expect }
    return (_expectTableLis = isDomesticEquity
      ? // 日株は、BPS(連)を表示ないため除く。
        set(_expectTableLis, "list", [
          filter(get(_expectTableLis, ["list", 0]), (_, index) => index !== 2),
        ])
      : _expectTableLis)
  }, [data, expectData])
  return (
    <div className={ClassNames("info-panel", { "split-division": !isSp })}>
      <div className="panel-splits panel-split-price-col">
        <div className="title-table-container">
          <div className="title-border">企業情報</div>
          <InfoTable
            list={infoTableList}
            data={data}
            className="table-striped table-index-detail"
            wrapperCls="index-detail-table-row"
          />
        </div>
      </div>
      <div className="panel-splits panel-split-price-col">
        <div className="title-table-container">
          <div className="title-border">業績予想</div>
          <InfoTable
            list={expectTableList}
            data={expectData}
            className="table-striped table-index-detail"
            wrapperCls="index-detail-table-row"
          />
        </div>
        {isDomesticEquity && (
          <div className="title-table-container">
            <div className="title-border">貸借</div>
            <div className="modal-nav-tab-item-nest-col">
              <CreditTable data={symbolData} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
